<ng-container *ngIf="state$ | async as state">
  <ng-container *ngIf="orderItemCount$ | async as count">
    <button
      mat-icon-button
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      (click)="miniCartService.openCart()"
      [class.no-count]="count === '0'"
    >
      <span
        [matBadge]="count"
        matBadgePosition="above after"
        matBadgeColor="accent"
        matBadgeSize="small"
      >
        <fa-icon icon="shopping-bag"></fa-icon>
      </span>
    </button>

    <ng-template
      xOverlayResponsiveHeight
      #overlay="xOverlayResponsiveHeight"
      cdkConnectedOverlay
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOrigin]="trigger"
      cdkConnectedOverlayPanelClass="fullwidth-mobile"
      [cdkConnectedOverlayHeight]="(overlay.height$ | async) ?? ''"
      [cdkConnectedOverlayOpen]="(miniCartService.cartIsOpen$ | async) ?? false"
      (overlayOutsideClick)="miniCartService.closeCart()"
      (overlayKeydown)="overlayKeyDown($event)"
    >
      <x-overlay-content>
        <x-triangle [target]="trigger"></x-triangle>
        <x-order-bag-overlay
          [order]="state.order"
          (closeBag)="miniCartService.closeCart()"
        ></x-order-bag-overlay>
      </x-overlay-content>
    </ng-template>
  </ng-container>
</ng-container>
